/* ================================================== */
/* PACKERY
/* ================================================== */

var grid, $packery

$(document).ready(function() {
	$grid = $('.packery-grid');

	$packery = $grid.packery({
		initLayout: false,
		itemSelector: '.packery-item',
		columnWidth: '.packery-sizer',
		percentPosition: true,
		transitionDuration: 0,
		gutter: 0
	});

	$packery.packery();

	$('.lazyload', $grid).on('load', function() {
		$packery.packery();
	});
});